// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import org.mifospay.core.network.model.entity.authentication.AuthenticationPayload
import org.mifospay.core.network.model.entity.user.User

@OptIn(InternalKtorfitApi::class)
public class _AuthenticationServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : AuthenticationService {
  override suspend fun authenticate(authPayload: AuthenticationPayload): User {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "authentication")
        }
        setBody(authPayload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<User>(),)!! 
  }
}

public class _AuthenticationServiceProvider : ClassProvider<AuthenticationService> {
  override fun create(_ktorfit: Ktorfit): AuthenticationService = _AuthenticationServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createAuthenticationService(): AuthenticationService = _AuthenticationServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
